import { formatDate } from "helpers"
import PropTypes from "prop-types"
import React from "react"
import { PopoverBody, UncontrolledPopover } from "reactstrap"

const VerticalTimeline = ({ events }) => {
  return (
    <ul className="verti-timeline list-unstyled">
      {events.map((e, idx) => {
        let ruleFraude
        if (e.isJson) {
          ruleFraude = JSON.parse(e?.description)
          if (ruleFraude?.rule === "rule_1") {
            ruleFraude["description"] = [`CEP: ${ruleFraude?.extras}`]
            ruleFraude["title"] = "Fraude (Regra 1) - Detalhes..."
          }
          if (ruleFraude?.rule === "rule_2") {
            ruleFraude["description"] = ["Retorno Birô:"]
            ruleFraude["description"].push(
              ...ruleFraude?.extras.map(
                el => `Número: ${el?.Number || ""}. CEP: ${el?.ZipCode || ""}`
              )
            )
            ruleFraude["title"] = "Fraude (Regra 2) - Detalhes..."
          }

          if (ruleFraude?.rule === "rule_3") {
            ruleFraude["description"] = ["Retorno Birô:"]
            ruleFraude["description"].push(
              ...ruleFraude?.extras.map(
                el => `Número: ${el?.Number || ""}. CEP: ${el?.ZipCode || ""}`
              )
            )
            ruleFraude["title"] = "Fraude (Regra 3) - Detalhes..."
          }

        }
        return (
          <li className={`event-list ${e.active ? "active" : ""}`} key={idx}>
            <div className="event-timeline-dot">
              <i
                className={`bx bx-right-arrow-circle font-size-18 ${
                  e.active ? "bx-fade-right" : ""
                }`}
              />
            </div>
            <div className="d-flex">
              <div className="flex-shrink-0 me-3">
                <h5 className="font-size-14">
                  {formatDate(e.title, "DD/MM/YYYY HH:mm:ss")}
                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                </h5>
              </div>
              <div className="flex-grow-1">
                {e.isJson && (
                  <React.Fragment>
                    <a
                      href="#"
                      className="text-decoration-none"
                      id={`PopoverLegacy-${idx}`}
                    >
                      {ruleFraude.title}
                    </a>
                    <UncontrolledPopover
                      placement="right"
                      target={`PopoverLegacy-${idx}`}
                      trigger="legacy"
                    >
                      <PopoverBody>
                        {ruleFraude?.description?.map((rf, id) => {
                          return (
                            <div style={{ fontSize: "14px" }} key={`rfP${id}`}>
                              {rf}
                            </div>
                          )
                        })}
                      </PopoverBody>
                    </UncontrolledPopover>
                  </React.Fragment>
                )}
                {!e.isJson && <div>{e.description}</div>}
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

VerticalTimeline.propTypes = {
  status: PropTypes.object,
}

export default VerticalTimeline
